export default __webpack_public_path__ + "static/Annual_Multimedia_logo_b-5e9f280a7f90d5cf4707a716a2f52b44.svg";